import { userConstants } from './../constants/user.constants';

let user = sessionStorage.getItem('user');
const initialState = user ? { user, isLoading: false } : {};

export function Bankdetails(state = initialState, action) {
  
  console.log("inside bankdetails function", action)
  switch (action.type) {
    case userConstants.UPDATEBANKDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.UPDATEBANKDETAILS_SUCCESS:
      const {res} = action
        console.log("Action", action)
      return {
        res,
        isLoading : false
      };
    case userConstants.UPDATEBANKDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}